// eslint-disable-next-line import/prefer-default-export
export const mediaBreakpoint = {
  medium: 1200,
  bigTablet: 992,
  tablet: 768,
  mobile: 576,
};

export const GAId = 'UA-131519040-1';
